type AttachmentOriginCandidate = {
  custom_field_value_id?: number | null;
  description?: string | null;
};

const normalizeToken = (value?: string | null): string =>
  String(value || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .trim();

export const isCustomFieldOriginAttachment = (
  attachment?: AttachmentOriginCandidate | null,
): boolean => {
  if (!attachment) return false;
  if (attachment.custom_field_value_id != null) return true;

  const description = normalizeToken(attachment.description);
  if (!description) return false;

  return (
    description.includes("upload de campo personalizado") ||
    description.includes("anexo originado de campo personalizado")
  );
};

